import { Component } from '@angular/core';
import { FormBuilder, Validators } from '@angular/forms';
import { MatDialog, MatDialogRef } from '@angular/material/dialog';
import { ManageProfileService } from '../manage-profile.service';
import { SpinnerComponent } from 'src/app/shared/component/spinner/spinner.component';
import { noWhitespaceValidator } from 'src/app/shared/custom-validator/white-space-validator';
import { passwordStrengthValidator } from 'src/app/shared/custom-validator/password-validator';

@Component({
  selector: 'app-change-password',
  templateUrl: './change-password.component.html',
  styleUrl: './change-password.component.scss',
})
export class ChangePasswordComponent {
  hideNewPwd: boolean = true;
  hideConfirmPwd: boolean = true;
  changePassword = this._formBuilder.group({
    oldPassword: ['', [Validators.required]],
    newPassword: ['',         [
          Validators.required,
          Validators.minLength(8),
          Validators.maxLength(20),
          noWhitespaceValidator(),passwordStrengthValidator()
        ],],
    confirmPassword: ['',         [
          Validators.required,
          Validators.minLength(8),
          Validators.maxLength(20),
          noWhitespaceValidator(),passwordStrengthValidator()
        ],],
  });
  passwordMatch:boolean = false
  samePwd:boolean = true
  constructor(
    private _formBuilder: FormBuilder,
    private dialogRef: MatDialogRef<ChangePasswordComponent>,
    private manageProfileService:ManageProfileService,
    public dialog: MatDialog
  ) {}
  cancelForm() {
    this.dialogRef.close()
  }
  updatePwd() {
    this.samePwd = this.isCurrPwdSameAsNewPwd()
    if(this.passwordMatch && this.samePwd){
      let apiData={
        oldPassword:this.changePassword.value.oldPassword,
        newPassword:this.changePassword.value.confirmPassword
      }
      const updateSpinnerRef = this.dialog.open(SpinnerComponent, {
        disableClose: true,
        panelClass: 'transparent-dialog',
      });
      this.manageProfileService.changePassword(apiData).subscribe({
        next: (data: any) => {
          if (data.status === 204) {
            this.dialogRef.close('success');
            updateSpinnerRef.close();
          }
        },
        error: (error: any) => {
          updateSpinnerRef.close();
        },
      });
    }
  }

  togglePasswordVisibility(field: string) {
    if (field === 'hideNewPwd') {
      this.hideNewPwd = !this.hideNewPwd;
    } else {
      this.hideConfirmPwd = !this.hideConfirmPwd;
    }
  }

  passwordMatchValidator() {
    const newPassword = this.changePassword.value.newPassword;
    const confirmNewPassword = this.changePassword?.value?.confirmPassword;
    if(newPassword && confirmNewPassword){
      if (newPassword !== confirmNewPassword) {
        this.passwordMatch =  false;
      }
      else{
        this.passwordMatch = true
      }
    }
  }

  isCurrPwdSameAsNewPwd(){
    const newPassword = this.changePassword.value.oldPassword;
    const currPwd = this.changePassword.value.confirmPassword;
  
    if (newPassword === currPwd) {
      return false;
    }
    return true;
  }
}
